export const getBlogOrNewsUrl = (blogOrNewsDetails: any) => {
  // Get the category name with fallbacks
  const categoryName = blogOrNewsDetails?.newsCategory?.name || 
                       blogOrNewsDetails?.category || 
                       blogOrNewsDetails?.topic || 
                       'blogs';
  
  // Get the slug
  const slug = blogOrNewsDetails?.slug?.toLowerCase();
  
  // Return the URL with proper fallbacks
  return `/${categoryName.toLowerCase()}/${slug}`;
}

export const getTextFromHtml = (html: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  return doc.body.textContent || "";
};
